import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=58f885b4"
import script from "./Admin.ts?vue&type=script&lang=ts&external"
export * from "./Admin.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports